import React from "react";
import "./../style/MiniDrawer.css";
import clsx from "clsx";
import { makeStyles, useTheme } from "@mui/styles";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import { Typography, Button } from "@mui/material";
import { MdError } from "react-icons/md";
import InsightsIcon from "@mui/icons-material/Insights";
import BoltIcon from "@mui/icons-material/Bolt";
import HistoryIcon from "@mui/icons-material/History";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { Box } from "@mui/material";

const drawerWidth = 225;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    zIndex: 10,
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    height: "100%",
  },
  content: {
    flexGrow: 1,
    //padding: theme.spacing(3),
  },
}));

export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  let date = "Loading...";
  if (props.lastDataPull !== "") {
    date = moment(props.lastDataPull).format("LLL");
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Box
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <List
          className="listStyle"
          style={{ height: "100%", justifyContent: "space-between" }}
        >
          <div className="listStyle" style={{ marginTop: "20px" }}>
            <NavLink
              to="/home"
              className="bigLink"
              activeClassName="activeBigLink"
              style={{ marginTop: "2vh" }}
            >
              <span className={open ? "menuItemTextOpen" : "menuItemText"}>
                Metrics
              </span>
            </NavLink>
            <NavLink
              to="/stations"
              className="bigLink"
              activeClassName="activeBigLink"
            >
              <span className={open ? "menuItemTextOpen" : "menuItemText"}>
                Stations
              </span>
            </NavLink>
            <NavLink
              to="/sessions"
              className="bigLink"
              activeClassName="activeBigLink"
            >
              <span className={open ? "menuItemTextOpen" : "menuItemText"}>
                Sessions
              </span>
            </NavLink>
          </div>
          {/* <Button
            className="activeBigLink"
            onClick={props.signOut}
            style={{ width: "100px", marginLeft: "30px" }}
          >
            <ExitToAppIcon fontSize="large" />
            <span>Logout</span>
          </Button> */}
        </List>
      </Box>
      {props.issueBanner ? (
        <div className="ConnectionError">
          <MdError transform="scale(1.25)" />
          <span style={{ paddingLeft: "15px" }}>
            EVolution Dashboard - unexpected outage. Some data may be missing.
          </span>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}
